import * as types from '../types/authTypes';

const storedToken = localStorage.getItem('token');

const initialState = {
  user: null,
  token: storedToken,
  isAuthenticated: false,
  loading: !!storedToken,  // wait for checkAuth() before letting ProtectedRoute redirect
  error: null,
  message: null,
  emailNotifications: null,
  emailNotifLoading: false,
  emailNotifSaving: false,
  vacations: [],
  vacationsLoading: false,
  vacationSaving: false,
  vacationError: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
    case types.REGISTER_REQUEST:
    case types.VERIFY_EMAIL_REQUEST:
    case types.FORGOT_PASSWORD_REQUEST:
    case types.RESET_PASSWORD_REQUEST:
    case types.UPDATE_PROFILE_REQUEST:
    case types.CHANGE_PASSWORD_REQUEST:
    case types.AUTH_CHECK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case types.LOGIN_SUCCESS:
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        error: null,
        message: action.payload.message
      };

    case types.REGISTER_PENDING_VERIFICATION:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        token: null,
        error: null,
        message: action.payload.message
      };
      
    case types.AUTH_CHECK_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload.user,
        error: null
      };
      
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: { ...state.user, ...action.payload.user },
        message: action.payload.message,
        error: null
      };
      
    case types.VERIFY_EMAIL_SUCCESS:
    case types.FORGOT_PASSWORD_SUCCESS:
    case types.RESET_PASSWORD_SUCCESS:
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: null
      };
      
    case types.LOGIN_FAILURE:
    case types.REGISTER_FAILURE:
    case types.VERIFY_EMAIL_FAILURE:
    case types.FORGOT_PASSWORD_FAILURE:
    case types.RESET_PASSWORD_FAILURE:
    case types.UPDATE_PROFILE_FAILURE:
    case types.CHANGE_PASSWORD_FAILURE:
    case types.AUTH_CHECK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    case types.LOGOUT:
      return {
        ...initialState,
        token: null,
        loading: false
      };
      
    case types.CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null,
        message: null
      };

    case types.FETCH_EMAIL_NOTIFICATIONS_REQUEST:
      return { ...state, emailNotifLoading: true };
    case types.FETCH_EMAIL_NOTIFICATIONS_SUCCESS:
      return { ...state, emailNotifLoading: false, emailNotifications: action.payload };
    case types.FETCH_EMAIL_NOTIFICATIONS_FAILURE:
      return { ...state, emailNotifLoading: false };

    case types.UPDATE_EMAIL_NOTIFICATIONS_REQUEST:
      return { ...state, emailNotifSaving: true };
    case types.UPDATE_EMAIL_NOTIFICATIONS_SUCCESS:
      return { ...state, emailNotifSaving: false, emailNotifications: action.payload };
    case types.UPDATE_EMAIL_NOTIFICATIONS_FAILURE:
      return { ...state, emailNotifSaving: false };

    case types.FETCH_VACATIONS_REQUEST:
      return { ...state, vacationsLoading: true, vacationError: null };
    case types.FETCH_VACATIONS_SUCCESS:
      return { ...state, vacationsLoading: false, vacations: action.payload };
    case types.FETCH_VACATIONS_FAILURE:
      return { ...state, vacationsLoading: false, vacationError: action.payload };

    case types.CREATE_VACATION_REQUEST:
    case types.UPDATE_VACATION_REQUEST:
    case types.DELETE_VACATION_REQUEST:
      return { ...state, vacationSaving: true, vacationError: null };

    case types.CREATE_VACATION_SUCCESS:
      return { ...state, vacationSaving: false, vacations: [...state.vacations, action.payload] };

    case types.UPDATE_VACATION_SUCCESS:
      return {
        ...state,
        vacationSaving: false,
        vacations: state.vacations.map(v => v.id === action.payload.id ? action.payload : v)
      };

    case types.DELETE_VACATION_SUCCESS:
      return {
        ...state,
        vacationSaving: false,
        vacations: state.vacations.filter(v => v.id !== action.payload)
      };

    case types.CREATE_VACATION_FAILURE:
    case types.UPDATE_VACATION_FAILURE:
    case types.DELETE_VACATION_FAILURE:
      return { ...state, vacationSaving: false, vacationError: action.payload };

    default:
      return state;
  }
};

export default authReducer;